const handleScaleInlineTailwind300 = "transition-transform duration-300 ease-out";
const handleEasInOut1000 = "transition-transform duration-1000 ease-in-out";
const handleAnimateZoomIn5000 = "flex-shrink-0 transform animate-zoomIn5000";
const handleFadeInUp1500Delay500 = "animate-fadeInUp animate-delay-500 opacity-0";

export { handleScaleInlineTailwind300, handleEasInOut1000, handleAnimateZoomIn5000, handleFadeInUp1500Delay500 };
